import React, { Fragment, useState, cloneElement } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';

import { withStyles } from '@mui/styles';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

import { ABORT, provider } from '../../_utils';

export const styles = {
    tab: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        overflow: 'hidden',
        minHeight: 0,
        flex: 1,
    },
    tabs: {
        minHeight: 34,
        borderBottom: '1px solid var(--line)',
    }
};

const  TabPanel = ({ children, value, index, ...other }) => (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      sx={value !== index ? { display: 'none' } : { height: '100%', width: '100%', minHeight: 0, overflow: 'hidden' }}
      {...other}
    >
      {value === index && (
        <Box sx={{ height: '100%', width: '100%', minHeight: 0, display: 'flex', flexDirection: 'column', flex: 1 }}>
          {children}
        </Box>
      )}
    </Box>
);

const TabLabel = ({ label, count }) => (
    <span>
        {label}
        {count !== undefined && count !== null && (
            <Box
                component="span"
                sx={{
                    fontFamily: 'var(--mono)',
                    fontSize: 10,
                    color: 'inherit',
                    opacity: 0.7,
                    ml: 0.6,
                }}
            >
                {count}
            </Box>
        )}
    </span>
);

const TabPanelElement = ({panels, classes, isSaving, variant, header, ...props}) => {
    const [tabIndex, setTabIndex] = useState(0);

    const changePanel = (event, newValue) => {
        if (newValue === tabIndex) return;
        provider(ABORT);
        setTabIndex(newValue);
    }

    const isSub = variant === 'sub';
    const tabs = (
        <Tabs
            value={tabIndex}
            onChange={changePanel}
            indicatorColor='primary'
            scrollButtons="auto"
            variant="scrollable"
            textColor="primary"
            className={classes.tabs}
            sx={isSub ? { px: 1.5, minHeight: 33, '& .MuiTab-root': { minHeight: 33, fontSize: 12, px: 1.4 } } : { minHeight: 34 }}
        >
            {panels.map((panel, index) => (
                <Tab
                    key={index}
                    disabled={isSaving}
                    label={<TabLabel label={panel.label} count={panel.count} />}
                    value={index}
                />
            ))}
        </Tabs>
    );
    const panes = panels.map((panel, index) => (
        <TabPanel key={index} value={tabIndex} index={index} className={classes.tab}>
            {panel.element}
        </TabPanel>
    ));

    if (header) {
        return (
            <div className="pc-page">
                {cloneElement(header, { tabs })}
                <div className="pc-stage">
                    {panes}
                </div>
            </div>
        );
    }

    return(
        <Fragment>
            {tabs}
            {panes}
        </Fragment>
    )
}

const mapStateToProps = (state, props) =>{
    const { fetch } = state;
    return {
        isSaving: !!(fetch && fetch.creat)
    }
  }
const enhance = compose(
    connect(mapStateToProps),
    withStyles(styles),
);

export default enhance(TabPanelElement);
